<template>
  <div v-if="client" class="lg:mr-44 bg-truegray-100 pb-16 lg:pb-0">
    <!-- Hero -->
    <div
      class="bg-expo_dblue hero-gradient exhibitor-hero w-full relative text-white flex flex-col justify-center items-center overflow-y-visible bg-cover bg-no-repeat bg-center"
      :style="{ backgroundImage: 'url(/img/careers-expo-exhibitors.jpg)' }"
    >
      <div
        class="max-w-3xl flex flex-col text-center z-10 px-12 lg:px-0 relative mt-16 lg:mt-0"
      >
        <h4 class="text-expo_red uppercase mb-4">Exhibitor Directory</h4>
        <h1 class="text-5xl">Online Expo</h1>

        <p class="text-lg">Discover your future</p>
      </div>
    </div>

    <div
      id="exhibitorHtml"
      :class="[exhibitors_loaded ? 'bg-truegray-100' : 'bg-truegray-500']"
      class="w-full px-6 lg:px-24 py-16 text-gray-900 relative z-40 flex flex-col items-center justify-center"
    >
      <div
        v-show="exhibitors_loaded"
        class="w-full max-w-8xl flex justify-between"
      >
        <!-- Filter -->
        <div class="w-full text-white max-w-5xl z-50 px-10 lg:px-0">
          <div
            class="w-full bg-white expo-filter relative shadow rounded-xl lg:h-12 filter-wrapper mb-8 flex flex-wrap lg:flex-nowrap"
          >
            <div
              class="rounded-xl relative flex lg:space-x-2 text-black flex-wrap lg:flex-nowrap w-full"
            >
              <!-- keyword search -->
              <TextInput
                v-if="showFilterDD"
                :value="exhibitor_filter.keywords"
                :label="'Searching for...'"
                :placeholder="'Exhibitor by Name'"
                :textarea="false"
                :placeholder_black="false"
                :fixed_width="true"
                :margin_bottom="false"
                :search_icon="true"
                :border_enabled="false"
                :response_selection_id="'filter_exhibitors_keywords'"
              />

              <!-- seperater && type -->
              <!--
                <div v-if="exhibitor_types.length > 0" class="w-px h-10 relative top-1 bg-truegray-300 hidden lg:block"></div> 
                <InputDropdown v-if="showFilterDD && exhibitor_types.length > 0"
                :label="'Type'"
                :selected="[exhibitor_filter.type]"
                :disabled="false"
                :placeholder="''"
                :options="exhibitor_types"
                :placeholder_black="false"
                :fixed_width="true"
                :text_xs="false"
                :margin_bottom="false"
                :search_icon='true'
                :border_enabled='false'
                :shadow_enabled='false'
                :response_selection_id="'filter_exhibitors_type'"
                /> 
              -->

              <!-- seperater && region -->
              <!--
                <div v-if="settings.regions" class="w-px h-10 relative top-1 bg-truegray-300 hidden lg:block"></div> 
                <InputDropdown v-if="showFilterDD && settings.regions"
                :label="'Region'"
                :selected="[exhibitor_filter.region]"
                :disabled="false"
                :placeholder="''"
                :options="settings.regions"
                :placeholder_black="false"
                :fixed_width="true"
                :text_xs="false"
                :margin_bottom="false"
                :search_icon='true'
                :border_enabled='false'
                :shadow_enabled='false'
                :response_selection_id="'filter_exhibitors_region'"
                /> 
              -->

              <!-- seperater && event -->
              <div
                v-if="events.length > 0"
                class="w-px h-10 relative top-1 bg-truegray-300 hidden lg:block"
              ></div>
              <InputDropdown
                v-if="showFilterDD && events.length > 0"
                :label="'Expo Location'"
                :selected="[exhibitor_filter.event]"
                :placeholder-default="'Choose location'"
                :options="events"
                :fixed-width-large="true"
                :fixed-width="true"
                :margin-bottom="false"
                :border-enabled="false"
                :shadow-enabled="false"
                :response-selection-id="'filter_exhibitors_event'"
              />
            </div>

            <!-- Search button -->
            <button
              class="btn relative w-full lg:w-40 h-12 lg:h-full p-0 m-0 ml-auto font-primary"
              :disabled="thinking"
              :class="
                thinking ? 'bg-primary cursor-not-allowed' : 'btn-expo-red'
              "
              @click="getExhibitors((filteredSearch = true))"
            >
              <div
                class="absolute inset-0 w-full flex justify-center items-center z-20"
              >
                <lottie v-if="thinking" :options="loadingAnimationOptions" />
              </div>
              <span :class="[thinking ? 'invisible' : '']">Search</span>
            </button>
          </div>

          <div class="w-full flex justify-end space-x-4 items-center z-20 mt-4">
            <button
              :class="[
                resetFiltersDisabled ? 'opacity-25 cursor-not-allowed' : '',
              ]"
              :disabled="resetFiltersDisabled"
              type="button"
              class="flex items-center cursor-pointer group"
              @click="resetFilters"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 mr-2 transform group-hover:rotate-90 transition-all duration-300 ease-in-out"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                />
              </svg>
              <span>Clear filters</span>
            </button>
          </div>
        </div>

        <!-- Grid toggle -->
        <div
          v-if="window.width >= 1400"
          class="w-full flex space-x-6 items-start justify-end mb-16"
        >
          <div
            :class="
              grid ? 'text-expo_red border-expo_red' : 'text-truegray-300'
            "
            class="p-2 border cursor-pointer flex items-center justify-center"
            @click="grid = true"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
              />
            </svg>
          </div>
          <div
            :class="
              !grid ? 'text-expo_red border-expo_red' : 'text-truegray-300'
            "
            class="p-2 border cursor-pointer flex items-center justify-center"
            @click="grid = false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>

      <div v-if="isFilterActive" class="w-full flex flex-col justify-center">
        <div class="flex items-center space-x-2 text-black mb-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
            />
          </svg>
          <h4 class="mb-0">Active Filters:</h4>
        </div>

        <h5
          v-if="exhibitor_filter.keywords"
          class="text-truegray-500 flex items-center text-sm"
        >
          <span class="text-truegray-400 mr-2 uppercase text-xs">Name:</span>
          {{ exhibitor_filter.keywords }}
        </h5>

        <!--
          <h5 class="text-truegray-500 flex items-center text-sm" v-if="exhibitor_filter.type">
          <span class="text-truegray-400 mr-2 uppercase text-xs">Type:</span>{{exhibitor_types[exhibitor_filter.type].text}}
          </h5>

          <h5 class="text-truegray-500 flex items-center text-sm" v-if="exhibitor_filter.region">
          <span class="text-truegray-400 mr-2 uppercase text-xs">Region:</span> {{selected_region}}
          </h5> 
        -->

        <h5
          v-if="exhibitor_filter.event"
          class="text-truegray-500 flex items-center text-sm"
        >
          <span class="text-truegray-400 mr-2 uppercase text-xs"
            >Expo Location:</span
          >
          {{ activeEvent }}
        </h5>

        <div class="w-full flex space-x-4 items-center z-20 mt-4">
          <button
            :class="[
              resetFiltersDisabled ? 'opacity-25 cursor-not-allowed' : '',
            ]"
            :disabled="resetFiltersDisabled"
            type="button"
            class="flex items-center cursor-pointer group text-expo_red"
            @click="resetFilters"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 mr-2 transform group-hover:rotate-90 transition-all duration-300 ease-in-out"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            <span>Reset Filters</span>
          </button>
        </div>
      </div>

      <div
        class="max-w-8xl transition-all duration-300 transform"
        :class="[
          exhibitors_loaded
            ? 'translate-y-0 opacity-100'
            : 'translate-y-8 opacity-0',
        ]"
      >
        <div
          v-if="exhibitors_loaded && grid"
          class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4"
        >
          <ExhibitorCardGrid
            v-for="(exhibitor, i) in exhibitors"
            :id="exhibitor.id"
            :key="i"
            :ref="'exhibitors-' + i"
            :exhibitor="exhibitor"
          />
        </div>

        <div v-if="exhibitors_loaded && !grid" class="grid grid-cols-1 gap-8">
          <ExhibitorCardColumn
            v-for="(exhibitor, i) in exhibitors"
            :id="exhibitor.id"
            :key="i"
            :ref="'exhibitors-' + i"
            :exhibitor="exhibitor"
          />
        </div>
      </div>

      <p v-if="exhibitors_loaded && exhibitors.length < 1" class="text-md">
        We could not find any exhibitors...
      </p>

      <!-- PAGINATION -->
      <div
        v-if="
          exhibitor_pagination.previouspage || exhibitor_pagination.nextpage
        "
        class="flex justify-between items-center mt-6 h-10"
      >
        <span
          :disabled="!exhibitor_pagination.previouspage"
          :class="[
            !exhibitor_pagination.previouspage
              ? 'opacity-25 cursor-not-allowed'
              : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
          ]"
          class="text-gray-500"
          @click="
            getExhibitors(isFilterActive, exhibitor_pagination.previouspage)
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 17l-5-5m0 0l5-5m-5 5h12"
            />
          </svg>
        </span>
        <span class="text-center text-xs"
          >Page {{ exhibitor_pagination.current_page }} of
          {{ exhibitor_pagination.total_pages }}</span
        >
        <!-- If resetFilterDisabled, we do not have filter data  -->
        <span
          :disabled="!exhibitor_pagination.nextpage"
          :class="[
            !exhibitor_pagination.nextpage
              ? 'opacity-25 cursor-not-allowed'
              : 'hover:text-gray-900 cursor-pointer transition ease-in-out duration-200',
          ]"
          class="text-gray-500"
          @click="getExhibitors(isFilterActive, exhibitor_pagination.nextpage)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </svg>
        </span>
      </div>
    </div>

    <!-- Latest posts -->
    <div
      v-show="posts.length > 0"
      class="fixed left-0 bottom-0 w-full z-70"
      :class="!posts_open ? '' : 'post_container_bg'"
    >
      <button
        class="btn bg-black text-white hover:text-expo_red px-8 py-4 rounded-b-none h-12 mb-0 ml-4 lg:ml-16"
        @click="posts_open = !posts_open"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          :class="!posts_open ? 'rotate-180 transform' : ''"
          class="h-8 w-8"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          ></path></svg
        >Latest News
      </button>
      <div
        :class="posts_open ? 'overflow-scroll' : 'overflow-hidden'"
        class="lg:mr-44 border-expo_red border-t-4 bg-expo_dblue"
      >
        <div
          :style="{ maxHeight: posts_container_height + 'vh' }"
          :class="posts_container_height > 0 ? 'post_container_minheight' : ''"
          class="post_container flex flex-col transition-all ease-in-out duration-300"
        >
          <!-- PAGINATION -->
          <button
            class="lg:hidden btn bg-expo_red mb-0 text-white hover:text-expo_red px-8 py-4 rounded-b-none h-12"
            @click="posts_open = !posts_open"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              :class="!posts_open ? 'rotate-180 transform' : ''"
              class="h-8 w-8"
            >
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path></svg
            >Latest News
          </button>
          <div
            :class="posts_open ? 'pt-12' : ''"
            class="px-12 lg:flex flex items-center justify-center relative z-30"
          >
            <div
              v-if="post_pagination.previouspage || post_pagination.nextpage"
              class="flex max-w-7xl justify-between items-center h-8 w-full"
            >
              <span
                :disabled="!post_pagination.previouspage"
                :class="[
                  !post_pagination.previouspage
                    ? 'opacity-25 cursor-not-allowed text-gray-500'
                    : 'hover:text-white cursor-pointer transition ease-in-out duration-200',
                ]"
                class="hidden text-gray-400"
                @click="getPosts(post_pagination.previouspage)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M11 17l-5-5m0 0l5-5m-5 5h12"
                  />
                </svg>
              </span>

              <button
                class="btn btn-trans-white m-0 h-8 text-white"
                @click="goToMagazine"
              >
                View All
              </button>
              <span
                :disabled="!post_pagination.nextpage"
                :class="[
                  !post_pagination.nextpage
                    ? 'opacity-25 cursor-not-allowed text-gray-500'
                    : 'hover:text-white cursor-pointer transition ease-in-out duration-200',
                ]"
                class="hidden text-gray-400"
                @click="getPosts(post_pagination.nextpage)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </span>
            </div>
          </div>
          <div
            :class="posts_open ? 'p-12' : ''"
            class="lg:flex items-start justify-center z-20 relative transform"
          >
            <div v-if="posts_loaded" class="relative">
              <div
                class="max-w-7xl relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-4 gap-4"
              >
                <PostsCard
                  v-for="(post, i) in posts"
                  :id="post.id"
                  :key="i"
                  :ref="'posts-' + i"
                  :post="post"
                  expo="true"
                />
              </div>
            </div>
            <div
              v-else
              class="relative -top-48 mb-24 h-52 flex flex-col justify-center items-center w-full max-w-7xl"
            >
              <lottie :options="loadingAnimationOptions" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus.js'
import { mapGetters } from 'vuex'
import * as loadingAnimation from '../../../shared/components/loading.json'
import ExhibitorCardGrid from '../components/ExhibitorCardGrid.vue'
import ExhibitorCardColumn from '../components/ExhibitorCardColumn.vue'
import PostsCard from '../../../shared/components/PostsCard.vue'
import InputDropdown from '../../../shared/components/InputDropdown.vue'
import TextInput from '../../../shared/components/InputText.vue'
import { parseURLParams } from '../../../js/util/helper.js'

export default {
  components: {
    ExhibitorCardGrid,
    ExhibitorCardColumn,
    InputDropdown,
    TextInput,
    PostsCard,
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      loadingAnimate: false,
      window: { width: 0, height: 0 },

      selected_region: null,

      //Exhibitor data
      exhibitors_loaded: false,
      thinking: false,
      grid: true,
      showFilterDD: true,
      resetFiltersDisabled: true,

      exhibitor_filter: {
        type: null,
        region: null,
        event: null,
        keywords: null,
      },

      isFilterActive: false,
      activeEvent: false,
      exhibitor_types: [],
      exhibitors: [],
      events: [],
      exhibitor_pagination: {
        current_page: null,
        total_pages: null,
        per_page: 9,
        next_page: null,
        previous_page: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null,
        nextpage: null,
        previouspage: null,
      },

      // Post data
      posts_open: false,
      posts_container_height: 0,
      posts: [],
      posts_loaded: false,
      post_pagination: {
        current_page: null,
        total_pages: null,
        per_page: 9,
        next_page: null,
        previous_page: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null,
        nextpage: null,
        previouspage: null,
      },
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      client: 'shared/getClient',
      storeEvents: 'expo/getEvents',
    }),
  },

  watch: {
    storeEvents: {
      handler: function (arr) {
        let dd = []
        arr.forEach((i) => {
          let evt = {}
          evt.text = i.title
          evt.id = i.id
          evt.value = i.id
          dd.push(evt)
        })
        this.$set(this, 'events', dd)
      },

      deep: true,
    },

    posts_open: {
      handler: function (val) {
        if (val) {
          this.$set(this, 'posts_container_height', 100)
          document.body.style.overflow = 'hidden'
        } else {
          this.$set(this, 'posts_container_height', 0)
          document.body.style.overflow = 'auto'
        }
      },

      deep: true,
    },

    exhibitor_filter: {
      handler: function (data) {
        if (
          data.keywords !== null ||
          data.region !== null ||
          data.type !== null ||
          data.event !== null
        ) {
          this.$set(this, 'resetFiltersDisabled', false)
        } else {
          this.$set(this, 'resetFiltersDisabled', true)
        }
        if (data.region) {
          let region = ''
          this.settings.regions.forEach((i) => {
            if (i.value === data.region) {
              region = i.text
            }
          })

          this.$set(this, 'selected_region', region)
        } else {
          this.$set(this, 'selected_region', null)
        }

        if (data.event) {
          let event = ''
          this.events.forEach((i) => {
            if (i.id === data.event) {
              event = i.title
            }
          })

          this.$set(this, 'activeEvent', event)
        }
      },

      deep: true,
    },
  },

  created() {
    if (this.client !== 'client2cloud') {
      this.$router.push('/')
    } // only allow Expo ( client 2 access for the /magazine template )
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },

  mounted() {
    let exhibitor_types = []
    this.settings.exhibitor_categories.forEach((i) => {
      exhibitor_types.push({ text: i.text, value: i.value })
    })

    this.$set(this, 'exhibitor_types', exhibitor_types)

    this.$set(this, 'events', this.storeEvents)

    let eventToken = false
    // Check for prefiltering
    let urlparams = parseURLParams(window.location.href)
    Object.keys(urlparams).forEach((key) => {
      if (key === 'event') {
        eventToken = urlparams[key][0]
      }
    })

    if (eventToken) {
      let id = parseInt(eventToken)
      this.$set(this.exhibitor_filter, 'event', id)
      // this.$set(this, 'isFilterActive', true);
      this.getExhibitors(true)
    } else {
      this.getExhibitors()
    }

    this.getPosts()

    EventBus.$on('filter_exhibitors_keywords', (option) => {
      this.$set(this.exhibitor_filter, 'keywords', option)
    })

    EventBus.$on('filter_exhibitors_type', (option) => {
      this.$set(this.exhibitor_filter, 'type', option)
    })

    EventBus.$on('filter_exhibitors_region', (option) => {
      this.$set(this.exhibitor_filter, 'region', option)
    })

    EventBus.$on('filter_exhibitors_event', (option) => {
      this.$set(this.exhibitor_filter, 'event', option)
    })
  },

  unmounted() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    scrollToMobilePosts() {
      this.$scrollTo('#mobileNews')
    },

    goToMagazine() {
      document.body.style.overflow = 'auto'
      this.$router.push({ path: '/exhibitor-latest-news' })
    },

    navigate() {},

    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      if (this.window.width < 1400) {
        this.$set(this, 'grid', true)
      }
    },

    // Exhibitor Methods
    getExhibitors(filteredSearch = false, getpage = null) {
      if (filteredSearch) {
        this.$set(this, 'thinking', true)
        this.$set(this, 'isFilterActive', true)
      }

      let filters = { page: getpage }
      if (this.exhibitor_filter.type) {
        filters.type = this.exhibitor_filter.type
      }
      if (this.exhibitor_filter.keywords) {
        filters.keywords = this.exhibitor_filter.keywords
      }
      if (this.exhibitor_filter.region) {
        filters.region = this.exhibitor_filter.region
      }
      if (this.exhibitor_filter.event) {
        filters.event = this.exhibitor_filter.event
      }

      axios.post('/api/exhibitors', filters).then((response) => {
        let result = response.data
        this.$set(this, 'thinking', false)
        if (result.success) {
          this.$set(this, 'exhibitors', result.exhibitors)
          this.$set(this, 'exhibitors_loaded', true)

          if (filteredSearch) {
            this.$scrollTo('#exhibitorHtml')
          }

          // pagination.total = total # of exhibitors. / by per_page, + 1. Pagination doesnt show when not needed so +1 is never wrong on single page
          let total_pages =
            Math.floor(
              response.data.pagination.total /
                response.data.pagination.per_page,
            ) + 1
          this.$set(
            this.exhibitor_pagination,
            'current_page',
            response.data.pagination.current_page,
          )
          this.$set(this.exhibitor_pagination, 'total_pages', total_pages)
          this.$set(
            this.exhibitor_pagination,
            'per_page',
            response.data.pagination.per_page,
          )
          this.$set(
            this.exhibitor_pagination,
            'last_page_url',
            response.data.pagination.last_page_url,
          )
          this.$set(
            this.exhibitor_pagination,
            'next_page_url',
            response.data.pagination.next_page_url,
          )
          this.$set(
            this.exhibitor_pagination,
            'prev_page_url',
            response.data.pagination.prev_page_url,
          )
          this.$set(
            this.exhibitor_pagination,
            'path',
            response.data.pagination.next_page_path,
          )

          let prev = null
          if (this.exhibitor_pagination.prev_page_url) {
            prev = this.exhibitor_pagination.prev_page_url.split('=')
            prev = prev[1]
          }

          let next = null
          if (this.exhibitor_pagination.next_page_url) {
            next = this.exhibitor_pagination.next_page_url.split('=')
            next = next[1]
          }

          this.$set(this.exhibitor_pagination, 'previouspage', prev)
          this.$set(this.exhibitor_pagination, 'nextpage', next)
        } else {
          //...
        }
      })
    },

    resetFilters() {
      this.$set(this, 'showFilterDD', false)
      this.exhibitor_filter.type = null
      this.exhibitor_filter.region = null
      this.exhibitor_filter.event = null
      this.exhibitor_filter.keywords = null
      this.$set(this, 'isFilterActive', false)
      setTimeout(() => {
        this.$set(this, 'showFilterDD', true)
        // this.getExhibitors();
      }, 1)
    },

    // Post methods
    getPosts(getpage = null) {
      axios
        .post('/api/cloud-online-expo-posts', {
          page: getpage,
          filter: { tags: [1, 2, 3] },
        })
        .then((response) => {
          let result = response.data
          if (result.success) {
            this.$set(this, 'posts', result.posts)
            this.$set(this, 'posts_loaded', true)

            // pagination.total = total # of posts. / by per_page, + 1. Pagination doesnt show when not needed so +1 is never wrong on single page
            let total_pages =
              Math.floor(
                response.data.pagination.total /
                  response.data.pagination.per_page,
              ) + 1
            this.$set(
              this.post_pagination,
              'current_page',
              response.data.pagination.current_page,
            )
            this.$set(this.post_pagination, 'total_pages', total_pages)
            this.$set(
              this.post_pagination,
              'per_page',
              response.data.pagination.per_page,
            )
            this.$set(
              this.post_pagination,
              'last_page_url',
              response.data.pagination.last_page_url,
            )
            this.$set(
              this.post_pagination,
              'next_page_url',
              response.data.pagination.next_page_url,
            )
            this.$set(
              this.post_pagination,
              'prev_page_url',
              response.data.pagination.prev_page_url,
            )
            this.$set(
              this.post_pagination,
              'path',
              response.data.pagination.next_page_path,
            )

            let prev = null
            if (this.post_pagination.prev_page_url) {
              prev = this.post_pagination.prev_page_url.split('=')
              prev = prev[1]
            }

            let next = null
            if (this.post_pagination.next_page_url) {
              next = this.post_pagination.next_page_url.split('=')
              next = next[1]
            }

            this.$set(this.post_pagination, 'previouspage', prev)
            this.$set(this.post_pagination, 'nextpage', next)
          } else {
            //...
          }
        })
    },
  },
}
</script>

<style scoped>
/* .expo-filter::after {
  position: absolute;
  width: calc(100% + 36px);
  height: calc(100% + 36px);
  background: #fff;
  border-radius: 12px;
  z-index: -1;
  opacity: 20%;
  left: -18px;
  top: -18px;
  content: ''
} */

.exhibitor-hero {
  height: 400px;
}

.hero-gradient::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  height: 100%;
  background: rgb(1, 23, 47);
  opacity: 70%;
}

.post-container {
  min-height: 0px;
  max-height: 0px;
  transition: all 0.3s ease-in-out;
}

.post_container_bg:before {
  content: '';
  background: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: -1;
  transition: all 0.3s ease-in-out;
}

@media screen and (min-width: 1024px) {
  .post_container_minheight {
    max-height: 600px;
  }
}
</style>
